import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./filter.scss";

interface FilterProps {
  onApply: (start: Date, end: Date) => void;

  defaultStart?: Date | null;
  defaultEnd?: Date | null;
}

const Filter: React.FC<FilterProps> = ({
  onApply,
  defaultStart,
  defaultEnd,
}) => {

  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 30);

  const [startDate, setStartDate] = useState<Date>(
    defaultStart ?? thirtyDaysAgo
  );
  const [endDate, setEndDate] = useState<Date>(defaultEnd ?? today);
  const [isOpen, setIsOpen] = useState(false);

  const handleApply = () => {
    setIsOpen(false);
    onApply(startDate, endDate);
  };

  const formatDisplayDate = (date?: Date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  };

  const displayText = `${formatDisplayDate(startDate)} - ${formatDisplayDate(
    endDate
  )}`;

  return (
    <div className="filter-wrapper">
      <button
        type="button"
        className="filter-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        📅 {displayText}
      </button>

      {isOpen && (
        <div className="filter-popup">
          <div className="date-picker-section">
            <label>Start Date:</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date ?? thirtyDaysAgo)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              placeholderText="Select start date"
              dateFormat="dd MMM yyyy"
            />
          </div>

          <div className="date-picker-section">
            <label>End Date:</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date ?? today)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              placeholderText="Select end date"
              dateFormat="dd MMM yyyy"
            />
          </div>

          <button className="apply-btn" onClick={handleApply}>
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default Filter;
